import VuetifyNumberInput from '@jzolago/vuetify-number-input';
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue'
import VModal from 'vue-js-modal';
import { KinesisContainer, KinesisElement } from 'vue-kinesis';
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue';
import ChevronUpIcon from 'vue-material-design-icons/ChevronUp.vue';
import CloseIcon from 'vue-material-design-icons/Close.vue';
import VueRellax from 'vue-rellax';
import VueTheMask from 'vue-the-mask';
import Vuetify from 'vuetify';
import App from './App.vue'
import './directives/scrollTo';
import './filters/money';
import './filters/plural';
import VueAnimateOnScroll from 'vue-animate-onscroll';
import VueRouter from 'vue-router';

import MainPage from './components/main-page/component';
import ContactsPage from './components/contacts-page/component';
import NotfoundPage from './components/notfound-page/component';

Vue.use(VueRouter);
Vue.use(Vuetify);

Vue.use(VuetifyNumberInput);
Vue.use(VModal);
Vue.use(VueTheMask);
Vue.use(VueRellax);
Vue.use(VueAnimateOnScroll);

Vue.component('close-icon', CloseIcon);
Vue.component('chevron-down', ChevronDownIcon);
Vue.component('chevron-up', ChevronUpIcon);

Vue.component('kinesis-container', KinesisContainer);
Vue.component('kinesis-element', KinesisElement);

Vue.config.productionTip = false;

const routes = [
  { path: '', component: MainPage },
  { path: '/contacts', component: ContactsPage },
  { path: '*', component: NotfoundPage },
];

new Vue({
  router: new VueRouter({ mode: 'history', routes }),
  vuetify: new Vuetify(),
  render: h => h(App)
}).$mount('#app')
